import * as Api from './api';
import * as actionTypes from './actionTypes';
import { sendHttpRequest, sendHttpCommandAndWaitForEvent } from 'actions/actionCreators/httpActions';
import { showError } from 'actions/actionCreators/snackbarActions';
import * as eventTypes from './eventTypes';
import { loadPartner, getCompanyInformation, loadPartnerHierarchy } from 'features/offer/edit/client/form/actionCreators';
import { getOfferAssetClientIsLoaded } from './selectors';

export function loadOfferAssetClient(documentId, siteId, documentTypeId) {
  return async (dispatch, getState) => {
    const isLoaded = getOfferAssetClientIsLoaded(getState());
    if (isLoaded) {
      return;
    }

    try {
      const client = await dispatch(sendHttpRequest(Api.getOfferAssetClient(documentId, siteId, documentTypeId)));
      if (client) {
        dispatch({ type: actionTypes.LOAD_OFFER_ASSET_CLIENT_SUCCEEDED, payload: { client } });
      }
    } catch (error) {
      dispatch(showError(error.message, error.correlationId));
      throw error;
    }
  };
}

export function loadAssetClientByUniqueId(documentId, siteId, uniqueId, partnerType, isExternal, callbackFn = () => {}) {
  return async dispatch => {
    try {
      dispatch({
        type: actionTypes.LOAD_OFFER_ASSET_CLIENT_BY_ID_STARTED
      });
      if (partnerType.typeCheck.isPF) {
        await dispatch(loadPartner(documentId, siteId, uniqueId, partnerType, isExternal));
        dispatch({
          type: actionTypes.LOAD_OFFER_ASSET_CLIENT_BY_ID_SUCCEEDED,
          payload: { uniqueId: uniqueId }
        });
      } else if (partnerType.typeCheck.isPJ || partnerType.typeCheck.isPFA) {
        await dispatch(getCompanyInformation(uniqueId, partnerType.partnerTypeId, callbackFn)).then(partner => {
          dispatch(loadPartnerHierarchy(partner?.eventBody?.partnerGroupId));
          dispatch({
            type: actionTypes.LOAD_OFFER_ASSET_CLIENT_BY_ID_SUCCEEDED,
            payload: { uniqueId: partner?.eventBody?.uniqueId ?? uniqueId, withErrors: !partner.ok }
          });
        });
      }
    } catch (error) {
      dispatch({
        type: actionTypes.LOAD_OFFER_ASSET_CLIENT_BY_ID_FAILED
      });
      dispatch(showError(error.message, error.correlationId));
    }
  };
}

export function invalidateOfferAssetClient(value, partnerId) {
  return async dispatch => {
    dispatch({
      type: actionTypes.OFFER_ASSET_CLIENT_DATA_INVALIDATED,
      payload: {
        partnerId: partnerId,
        partnerType: value
      }
    });
  };
}

export function updateOfferAssetClient(documentId, siteId, client) {
  return async dispatch => {
    dispatch({ type: actionTypes.SAVE_OFFER_ASSET_CLIENT_STARTED });
    dispatch(
      sendHttpCommandAndWaitForEvent(Api.updateOfferAssetClient(documentId, siteId, client), 'RunningOfferCommand', [
        eventTypes.OFFER_ASSET_CLIENT_UPDATED
      ])
    )
      .then(event => {
        if (event.ok) {
          dispatch({
            type: actionTypes.SAVE_OFFER_ASSET_CLIENT_SUCCEEDED,
            payload: {
              partner: {
                ...client,
                generalData: {
                  ...client.generalData,
                  firstName: client.generalData.firstName?.trim(),
                  lastName: client.generalData.lastName?.trim(),
                  partnerName: event.eventBody.clientName?.trim(),
                  uniqueId: event.eventBody.uniqueId?.trim()
                },
                contactData: {
                  ...client.contactData,
                  masterContactInfoId: event.eventBody.masterContactInfoId,
                  dealerContactInfoId: event.eventBody.dealerContactInfoId,
                  dealerContactModePhoneId: event.eventBody.dealerContactModePhoneId,
                  dealerContactModeEmailId: event.eventBody.dealerContactModeEmailId
                },
                dealerContactInfos: event.eventBody.dealerContactInfos ?? client.contactData.dealerContactInfos,
                dealerContactEmails: event.eventBody.dealerContactEmails ?? client.contactData.dealerContactEmails,
                dealerContactPhones: event.eventBody.dealerContactPhones ?? client.contactData.dealerContactPhones,
                masterPartnerId: event.eventBody.masterPartnerId
              },
              documentId,
              siteId,
              partnerId: event.eventBody.clientId
            }
          });
        } else {
          dispatch({ type: actionTypes.SAVE_OFFER_ASSET_CLIENT_FAILED, payload: { documentId, siteId, error: event } });
        }
      })
      .catch(error => {
        dispatch(showError(error.message, error.correlationId));
        dispatch({ type: actionTypes.SAVE_OFFER_ASSET_CLIENT_FAILED, payload: { documentId, siteId } });
      });
  };
}

export function toggleAssetClientCard(_, expanded) {
  return dispatch => {
    dispatch({ type: actionTypes.TOGGLE_OFFER_ASSET_CLIENT_CARD, payload: { expanded } });
  };
}

export function cancelAssetClientChanges(documentId, siteId) {
  return { type: actionTypes.CANCEL_OFFER_ASSET_CLIENT_CHANGES, payload: { documentId, siteId } };
}
